import React, { Component, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Form from "../Comman/Form";
import http from "../../Services/httpService";
import config from "../../config.json";
import auth from "../../Services/authService";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import AddWorkingHrs from "./AddWorkingHrs";
import {
  getAllMonths,
  getAllYears,
  getDateOnly,
  getFieldData,
  getMonthName,
  getTotalHours,
  sanitizeEvent,
  sanitizeEventList,
  toLocalDate,
} from "../../Services/appService";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { addNewTmLog, getTmLogAddedStatus } from "../../app/store/timeLog";
import {
  getAppTasks,
  getCandidateApps,
  loadAppRuningTasks,
  loadCandidateApps,
} from "../../app/store/candidate";
import {
  appDocumentUploaded,
  getAppDocUploadStatus,
  uploadAppDocuments,
} from "../../app/store/documents";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";

const AddNewTimeLog = (props) => {
  const {
    showHide: tmShowHide,
    handleShowHide,
    viewType,
    selectedObj,
    allTimeLogs,
    candidateObj,
    timeLogInvoices,
    projectStartDate,
  } = props;

  const localizer = momentLocalizer(moment);

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [allEvents, setAllEvents] = useState([]);
  const [docType, setDocType] = useState("monthly");
  const [monthlyHrs, setMonthlyHrs] = useState("");
  const [chkMonthlyHrs, setChkMonthlyHrs] = useState("");
  const [monthlyDays, setMonthlyDays] = useState("");
  const [documents, setDocuments] = useState([]);
  const [wrkHrShowHide, setWrkHrShowHide] = useState(false);
  const [dtObj, setDtObj] = useState(null);
  const [currentWfTask, setCurrentWfTask] = useState(null);
  const [saveTmWithDocs, setSaveTmWithDocs] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [prjStartYear, setPrjStartYear] = useState(0);
  const [prjStartMonth, setPrjStartMonth] = useState(0);
  const [prjStartMonthDay, setPrjStartMonthDay] = useState(0);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appTasksSelector = useSelector(getAppTasks);
  const appDocUploadStatusSelector = useSelector(getAppDocUploadStatus);
  const tmLogAddedStatusSelector = useSelector(getTmLogAddedStatus);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
      dispatch(loadCandidateApps(currentUser.id));
  }, []);

  useEffect(() => {
    if (!tmShowHide) {
      //setAllEvents([]);
      setDocuments([]);
    }
  }, [tmShowHide]);

  useEffect(() => {
    if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
      const mainWorkflow = candidateAppsSelector.filter(
        (x) => x.workflowType === 1
      );
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        if (appTasksSelector.length === 0)
          dispatch(loadAppRuningTasks(wf.oldWorkflowId, currentUser.id));
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(
        (x) => x.wiid > 0 && x.wfPhase === "Approved"
      );
      let firstAppTasks = [];
      if (filterTasks.length > 0) {
        firstAppTasks = filterTasks[filterTasks.length - 1];
        setCurrentWfTask(firstAppTasks);
      }
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (allTimeLogs.length > 0) {
      let shouldClearEvents = false;
      const events = [];
      allTimeLogs.forEach((t) => {
        if (!t.workingHrs) return;

        const wt = JSON.parse(t.workingHrs);

        wt.forEach((w) => {
          if (w.type === "m") return;
          const dt = toLocalDate(w.start);
          events.push({
            start: dt,
            end: dt,
            title: w.title,
          });
        });
      });

      setAllEvents(events);
      setDocuments([]);
    }
  }, [allTimeLogs, tmShowHide]);

  useEffect(() => {
    if (selectedObj) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);
      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
      if (selectedObj.workingHrs) {
        // console.log(selectedObj, "selectedObj")
        try {
          const hrsArray = JSON.parse(selectedObj.workingHrs);
          if (hrsArray.length > 0) {
            const { title, days, type } = hrsArray[0];
            if (type) {
              if (title || days) {
                setChkMonthlyHrs("monthly");
                setMonthlyHrs(title);
                setMonthlyDays(days);
              }
            }
          }
        } catch (err) {
          console.error("Failed to parse workingHrs:", err);
        }
      }
    } else {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth();
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    if (projectStartDate) {
      const dur = new Date(projectStartDate);
      setPrjStartYear(dur.getFullYear());
      setPrjStartMonth(dur.getMonth() + 1);
      setPrjStartMonthDay(dur.getDate());
    } else {
      setPrjStartYear(0);
      setPrjStartMonth(0);
    }
  }, [selectedObj]);

  const handleOnChange = ({ currentTarget }) => {
    const id = currentTarget.id.split("_")[1];
    const name = currentTarget.id.split("_")[0];
    const { timeLogs } = this.state;
    let obj = timeLogs.filter((x) => x.id === parseInt(id))[0];
    const index = timeLogs.findIndex((x) => x.id === parseInt(id));
    obj[name] = currentTarget.value;
    timeLogs[index] = obj;
    //this.setState({ timeLogs });
  };

  const doSubmit = (type) => {
    if (type === "reset") setSelectedYear(null);
    const selectedTimeLog = allTimeLogs.filter(
      (x) =>
        x.year === parseInt(selectedYear) && x.month === parseInt(selectedMonth)
    );
    if (selectedTimeLog.length > 0) checkInvoiceStatus(selectedTimeLog);
    else saveTmLogs();
  };

  const checkInvoiceStatus = (selectedTimeLog) => {
    const tmLog = selectedTimeLog[0];
    const invType = "subcontractor";
    const checkApproved = timeLogInvoices.filter(
      (x) =>
        x.timeLogId === tmLog.id &&
        x.invoiceType === invType &&
        x.status === true
    );
    if (checkApproved.length > 0)
      getAlert("", "Invoice already approved", "error");
    else saveTmLogs();
  };

  const saveTmLogs = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you have entered the correct hours for the week/month?",
      "warning"
    );
    if (result.isConfirmed) {
      setSaveBtnProccess(true);
      if (documents.length > 0) saveTmDocs();
      else saveTimeLogs(0);
    }
  };

  const saveTmDocs = () => {
    const frmData = new FormData();
    frmData.append("message", "Time Sheet");
    frmData.append("workflowTask", JSON.stringify(currentWfTask));
    frmData.append("userId", currentUser.id);
    frmData.append("docType", docType + "_time_sheet");
    documents.map((file, key) =>
      frmData.append("files[" + key + "]", file.file)
    );
    dispatch(uploadAppDocuments(frmData));
    setSaveTmWithDocs(true);
  };

  const saveTimeLogs = (docId) => {
    const selYear = Number(selectedYear);
    const selMonthNum = Number(selectedMonth);

    // Filter events by selected year/month (NO Date object)
    const filterEvents = allEvents.filter((e) => {
      const [year, month] = e.start.split("-").map(Number);
      return year === selYear && month === selMonthNum;
    });

    const tmObj = {};

    // MONTHLY HOURS MODE
    if (chkMonthlyHrs === "monthly" && Number(monthlyHrs) > 0) {
      const selMonth = selMonthNum < 10 ? `0${selMonthNum}` : selMonthNum;

      const newEvents = [
        {
          start: `${selYear}-${selMonth}-01`,
          end: `${selYear}-${selMonth}-02`,
          title: Number(monthlyHrs),
          type: "m",
          days: monthlyDays || 0,
        },
      ];

      tmObj.workingHrs = JSON.stringify(newEvents);
    }
    // DAILY MODE
    else {
      tmObj.workingHrs =
        filterEvents.length > 0 ? JSON.stringify(filterEvents) : null;
    }

    // Metadata
    tmObj.candidateId = candidateObj.performerid;
    tmObj.subcontractorId = candidateObj.validId;
    tmObj.docId = docId;
    tmObj.docUploadType = docType;
    tmObj.year = selYear;
    tmObj.month = selMonthNum;

    if (selectedObj?.id > 0) {
      tmObj.id = selectedObj.id;
    }

    dispatch(addNewTmLog(tmObj));
  };

  useEffect(() => {
    if (tmLogAddedStatusSelector) {
      if (selectedObj?.id > 0) getAlert("", "Updated Successfully", "success");
      else getAlert("", "Added Successfully", "success");

      setSaveBtnProccess(false);
      handleShowHide("save");
    }
  }, [tmLogAddedStatusSelector]);

  useEffect(() => {
    if (appDocUploadStatusSelector > 0 && saveTmWithDocs) {
      saveTimeLogs(appDocUploadStatusSelector);
      setSaveTmWithDocs(false);
      dispatch(appDocumentUploaded(null));
    }
  }, [appDocUploadStatusSelector]);

  const handleSelect = (wrkHr) => {
    if (!dtObj) return;

    const { start, end } = dtObj;

    // Always convert selected date into YYYY-MM-DD
    const selectedDate = getDateOnly(start);

    // Clean list (remove any events that have times)
    let updatedEvents = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find all events on this day
    const sameDayEvents = updatedEvents.filter((x) => x.start === selectedDate);

    if (sameDayEvents.length > 0) {
      // Take first one to update
      const target = sameDayEvents[0];
      const targetIndex = updatedEvents.indexOf(target);

      // Remove duplicates on same date (if any)
      if (sameDayEvents.length > 1) {
        sameDayEvents.slice(1).forEach((dupEv) => {
          const dupIndex = updatedEvents.indexOf(dupEv);
          if (dupIndex !== -1) updatedEvents.splice(dupIndex, 1);
        });
      }

      // Update the selected event
      updatedEvents[targetIndex] = {
        ...updatedEvents[targetIndex],
        title: wrkHr,
      };
    } else {
      // Add new event (date-only)
      updatedEvents.push({
        start: selectedDate,
        end: selectedDate,
        title: wrkHr,
      });
    }

    setAllEvents(updatedEvents);
    setWrkHrShowHide(false);
    setDtObj(null);
  };

  const handleeEditSelect = (wrkHr) => {
    if (!dtObj) return;

    // Always sanitize date fields from dtObj
    const targetStart = getDateOnly(dtObj.start);
    const targetEnd = getDateOnly(dtObj.end);
    const targetTitle = dtObj.title;

    // Always sanitize event list to keep everything date-only
    const events = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find correct event (safe for USA/India timezones)
    const index = events.findIndex((x) => {
      return (
        x.start === targetStart &&
        x.end === targetEnd &&
        x.title === targetTitle
      );
    });

    if (index === -1) return; // No match found

    // Update the found event immutably
    const updatedEvents = [...events];
    updatedEvents[index] = {
      ...updatedEvents[index],
      title: wrkHr,
    };

    setAllEvents(updatedEvents);
  };

  const handleYearChange = ({ currentTarget }) => {
    setSelectedYear(currentTarget.value);
    const newDt = new Date(currentTarget.value, selectedMonth - 1, 1);
    setSelectedDate(newDt);
  };

  const handleMonthChange = ({ currentTarget }) => {
    if (prjStartYear === selectedYear && currentTarget.value < prjStartMonth) {
      getAlert(
        "",
        `Month should be greater than or equal to ${
          months.find((x) => x.id === prjStartMonth).name
        }`,
        "error"
      );
      return;
    }
    setSelectedMonth(currentTarget.value);
    const newDt = new Date(selectedYear, currentTarget.value - 1, 1);
    setSelectedDate(newDt);
  };

  const handleDateChanged = (date) => {
    // Extract safe local date (prevents timezone shift)
    const getLocalDateParts = (d) => {
      const dt = new Date(d);
      return {
        year: dt.getFullYear(),
        month: dt.getMonth(), // 0-based
        day: dt.getDate(),
        full: dt,
      };
    };

    const { year, month, full } = getLocalDateParts(date);

    const cyear = new Date().getFullYear();
    const cmonth = new Date().getMonth();

    const findYear = years.filter((x) => x.name === year);

    if (
      (year === cyear && month <= cmonth && findYear.length > 0) ||
      (year < cyear && findYear.length > 0)
    ) {
      setSelectedYear(year);
      setSelectedMonth(month + 1); // convert 0-based → 1-based
      setSelectedDate(full); // safe Date object
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (let file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleWrkHrShowHide = (obj) => {
    if (!obj) {
      setWrkHrShowHide(false);
      setDtObj(null);
      return;
    }

    const dt = new Date(obj.start); // Date user clicked
    const now = new Date();

    // Compare only the date (ignore time)
    const currentDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const targetDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

    // 🔢 Convert all year/month/day values to numbers
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    if (dt.getMonth() + 1 !== selectedMonthNum) return;

    const showError = (msg) => getAlert("", msg, "error");

    // --- 1️⃣ Block: Before project start ---
    if (
      selectedYearNum < prjStartYearNum ||
      (selectedYearNum === prjStartYearNum &&
        selectedMonthNum < prjStartMonthNum)
    ) {
      return showError(
        "You cannot add working hours for months before the project start date."
      );
    }

    // --- 🆕 Additional Day Check for Project Start Month ---
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum
    ) {
      if (dt.getDate() < prjStartMonthDayNum) {
        return showError(
          `You cannot add working hours before the project start date (${prjStartMonthDayNum}/${prjStartMonthNum}/${prjStartYearNum}).`
        );
      }
    }

    // --- 2️⃣ Block: Future months ---
    if (
      selectedYearNum > currentYear ||
      (selectedYearNum === currentYear && selectedMonthNum > currentMonth)
    ) {
      return showError("You cannot add working hours for future months.");
    }

    // --- 3️⃣ Current month handling ---
    if (selectedYearNum === currentYear && selectedMonthNum === currentMonth) {
      if (targetDate > currentDate) {
        return showError("You cannot add working hours for future dates.");
      }

      // ✅ Allow today and past dates in current month
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 4️⃣ Past months (after project start, before current month) ---
    if (
      (selectedYearNum > prjStartYearNum ||
        (selectedYearNum === prjStartYearNum &&
          selectedMonthNum >= prjStartMonthNum)) &&
      (selectedYearNum < currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum < currentMonth))
    ) {
      // ✅ Allow all days in past months (after start)
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 5️⃣ Fallback ---
    showError("Unable to add working hours for this date.");
  };

  const handleChkMonthly = ({ target }) => {
    if (target.checked) {
      setChkMonthlyHrs("monthly");
    } else {
      setChkMonthlyHrs("");
    }
  };

  const handleReset = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Reset the entered hours for the week(s)/month?",
      "warning"
    );

    if (!result.isConfirmed) return;

    // Restore header fields
    if (selectedObj?.id > 0) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);

      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
    } else {
      const dt = new Date();
      setSelectedYear(dt.getFullYear());
      setSelectedMonth(dt.getMonth() + 1);
      setSelectedDate(dt);

      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    // Build event list safely (with dateUtils)
    const events = [];

    allTimeLogs.forEach((t) => {
      if (!t.workingHrs) return;

      const wt = JSON.parse(t.workingHrs);

      wt.forEach((w) => {
        // Convert any format → YYYY-MM-DD safely
        const cleanEvent = sanitizeEvent({
          start: w.start,
          end: w.start,
          title: w.title,
        });

        events.push(cleanEvent);
      });
    });

    setAllEvents(events);
    getAlert("", "Reset Successfully", "success");
  };

  const eventStyleGetter = (event) => {
    const style = {
      backgroundColor: "black", // Conditional colors based on event time
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "none",
    };
    return {
      style,
    };
  };

  let filterMonths = months.filter((x) => x.id <= new Date().getMonth() + 1);
  if (selectedYear < new Date().getFullYear()) filterMonths = months;

  return (
    <>
      <Modal show={tmShowHide} size="xl">
        <Modal.Header closeButton onHide={() => handleShowHide(null)}>
          <Modal.Title>Add/Edit Time Log</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border">
          <div className="row">
            <div className="col-md-6 form-group">
              <select
                name="year"
                id="year"
                className="form-control"
                onChange={handleYearChange}
                value={selectedYear}
              >
                <option value="">Select Year</option>
                {years
                  .filter(
                    (x) =>
                      x.name <= new Date().getFullYear() &&
                      x.name >= prjStartYear
                  )
                  .map((y) => (
                    <option value={y.name}>{y.name}</option>
                  ))}
              </select>
            </div>

            <div className="col-md-6 form-group">
              <select
                name="month"
                id="month"
                className="form-control"
                onChange={handleMonthChange}
                value={selectedMonth}
              >
                <option value="">Select Month</option>
                {filterMonths.map((m) => (
                  <option value={m.id}>{m.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-12">
              <h4>
                Total Hours :{" "}
                {selectedObj?.workingHrs &&
                  getTotalHours(selectedObj?.workingHrs)}
              </h4>
            </div>
            <div className="col-md-12 form-inline">
              <div className="custom-control custom-radio mb-3">
                <input
                  name="docType"
                  className="custom-control-input"
                  id="timeSheetWeekly"
                  type="radio"
                  onChange={() => setDocType("weekly")}
                  value="weekly"
                  checked={docType === "weekly"}
                />
                <label
                  className="custom-control-label mr-2"
                  htmlFor="timeSheetWeekly"
                >
                  Upload weekly time sheets
                </label>
              </div>
              <div className="custom-control custom-radio mb-3">
                <input
                  name="docType"
                  className="custom-control-input"
                  id="timeSheetMonthly"
                  type="radio"
                  onChange={() => setDocType("monthly")}
                  value="monthly"
                  checked={docType === "monthly"}
                />
                <label
                  className="custom-control-label"
                  htmlFor="timeSheetMonthly"
                >
                  Upload monthly time sheet
                </label>
              </div>
            </div>

            <div className="col-md-12" style={{ height: "350px" }}>
              <Calendar
                selectable
                localizer={localizer}
                events={allEvents}
                date={selectedDate}
                views={["month"]} // "week", "work_week"
                onSelectEvent={handleWrkHrShowHide}
                onSelectSlot={handleWrkHrShowHide}
                onNavigate={handleDateChanged}
                eventPropGetter={eventStyleGetter}
                //onView={(view) => setState({ selectedView: view })}
              />
            </div>
            <div className="col-12">
              <hr className="border-top border-2 border-dark my-3" />
            </div>

            <h4 className="ml-3">For Non-billable staff</h4>
            <div className="col-md-12">
              <div className="custom-control custom-checkbox mb-3">
                <input
                  name="chkMonthlyHrs"
                  className="custom-control-input"
                  id="chkMonthlyHrs"
                  type="checkbox"
                  onChange={handleChkMonthly}
                  value="monHrs"
                  checked={chkMonthlyHrs === "monthly"}
                />
                <label
                  className="custom-control-label mr-2"
                  htmlFor="chkMonthlyHrs"
                >
                  Check Monthly Hour(s)
                </label>
              </div>
            </div>
            {chkMonthlyHrs === "monthly" && (
              <>
                <div className="col-md-6 form-group">
                  <label htmlFor="monthlyHrs" className="form-control-label">
                    Enter Monthly Hour(s)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="monthlyHrs"
                    name="monthlyHrs"
                    value={monthlyHrs}
                    placeholder="Enter Monthly Hours"
                    onChange={({ currentTarget }) =>
                      setMonthlyHrs(currentTarget.value)
                    }
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label htmlFor="monthlyDays" className="form-control-label">
                    Enter Total Day(s)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="monthlyDays"
                    name="monthlyDays"
                    value={monthlyDays}
                    placeholder="Enter Total Days"
                    onChange={({ currentTarget }) =>
                      setMonthlyDays(currentTarget.value)
                    }
                  />
                </div>{" "}
              </>
            )}
            {docType === "weekly" ? (
              <div className="col-md-12 mt-2">
                <table className="table table-bordered">
                  <thead className="bg-lighter">
                    <tr>
                      <th>
                        <b>Week</b>
                      </th>
                      <th>
                        <b>Upload weekly approved time sheets</b>
                      </th>
                      <th>
                        <b>Week</b>
                      </th>
                      <th>
                        <b>Upload weekly approved time sheets</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>
                        <input
                          type="file"
                          id="week1"
                          name="week1"
                          className="form-control"
                          onChange={onFileChange}
                        />
                      </td>
                      <td>2</td>
                      <td>
                        <input
                          type="file"
                          id="week2"
                          name="week2"
                          className="form-control"
                          onChange={onFileChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>
                        <input
                          type="file"
                          id="week3"
                          name="week3"
                          className="form-control"
                          onChange={onFileChange}
                        />
                      </td>
                      <td>4</td>
                      <td>
                        <input
                          type="file"
                          id="week4"
                          name="week4"
                          className="form-control"
                          onChange={onFileChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <>
                <div className="col-md-6 mt-2">
                  <label htmlFor="timeSheet" className="form-control-label">
                    Upload monthly approved time sheet
                  </label>
                  <input
                    type="file"
                    name="timeSheet"
                    id="timeSheet"
                    className="form-control"
                    onChange={onFileChange}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <label htmlFor="signDoc" className="form-control-label">
                    Upload monthly supporting document (If Required)
                  </label>
                  <input
                    type="file"
                    name="signDoc"
                    id="signDoc"
                    className="form-control"
                    onChange={onFileChange}
                  />
                </div>{" "}
              </>
            )}

            <div className="col-md-12 mt-3">
              <b>
                Please note: Documents that are password-protected or restricted
                from printing should not be uploaded.
              </b>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {viewType !== "invoice" && (
            <>
              <button
                className="btn btn-sm btn-outline-default"
                onClick={handleReset}
              >
                <i class="fa fa-refresh" aria-hidden="true"></i> Reset
              </button>
              <button
                className="btn btn-sm btn-outline-default"
                disabled={saveBtnProccess}
                onClick={() => doSubmit("save")}
              >
                {saveBtnProccess ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : (
                  <i class="fa fa-check" aria-hidden="true"></i>
                )}{" "}
                Save
              </button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      {wrkHrShowHide && (
        <AddWorkingHrs
          handleShowHide={handleWrkHrShowHide}
          showHide={wrkHrShowHide}
          selectedObj={dtObj}
          handleSelect={handleSelect}
          handleeEditSelect={handleeEditSelect}
          allEvents={allEvents}
        ></AddWorkingHrs>
      )}
    </>
  );
};

export default AddNewTimeLog;
